import * as React from 'react';
import classnames from 'classnames';
import axios from 'axios';
import { DealerStaticViewer } from '@wix/react-dealer-viewer';
import ErrorBoundary from '@wix/da-shared-react/pkg/ErrorBoundary';
import CloseIconBold from '@wix/da-shared-react/pkg/Icons/CloseBold';
import ButtonB5 from '@wix/da-shared-react/pkg/Button/ButtonB5';
import { BiEventType } from '@wix/da-shared-react/pkg/biLogger/constants';
import { IconSize } from '@wix/da-shared-react/pkg/Icons/IconWrap';

import s from './DealerAd.scss';

export interface Props {
  realEstateId: string;
  userGuid: string;
  biClientId: string;
  additionalParams?: { [s: string]: string }; // TODO remove if we dont use it
  withCloseButton: boolean;
  translationVersion: string;
}

export interface State {
  isEmpty: boolean;
  loaded: boolean;
  banners: any[];
}

function sendCommand(command: string, realEstateId: string) {
  if (window.parent.postMessage) {
    const payload = {
      type: 'dealerAd',
      command,
      realEstateId,
    };
    window.parent.postMessage(payload, '*');
  }
}

class DealerAd extends React.Component<Props, State> {
  readonly state: State = {
    loaded: false,
    banners: [],
    isEmpty: false,
  };

  componentDidMount() {
    axios
      .create(/* do not use wix axios config as it messes up CORS OPTIONS request for preflight */)
      .get('https://www.wix.com/_api/wix-dealer-webapp/da/offers', {
        headers: {},
        params: {
          realEstateId: this.props.realEstateId,
          userGuid: this.props.userGuid || '',
        },
      })
      .then(response => {
        if (
          response &&
          response.data &&
          response.data.dealerData &&
          response.data.dealerData[this.props.realEstateId] &&
          response.data.dealerData[this.props.realEstateId].offers
        ) {
          this.setState({
            loaded: true,
            banners: response.data.dealerData[this.props.realEstateId].offers,
          });
          sendCommand('ad-filled', this.props.realEstateId);
        } else {
          this.onEmpty();
        }
      })
      .catch(this.onEmpty);
  }

  render() {
    const { loaded, banners, isEmpty } = this.state;
    if (isEmpty || (loaded && (!banners || !banners.length))) {
      return null; // collapse
    }
    // Pick random banner
    const banner = banners[Math.floor(Math.random() * banners.length)];
    return (
      <ErrorBoundary>
        <div className={classnames(s['root'])}>
          {loaded && this.renderBanner(banner)}
        </div>
      </ErrorBoundary>
    );
  }

  renderBanner = banner => {
    const {
      withCloseButton,
      userGuid,
      biClientId,
      realEstateId,
      additionalParams,
    } = this.props;
    return (
      <div key={banner.bannerId} className={s['banner-wrapper']}>
        <DealerStaticViewer
          dealerOptions={additionalParams}
          bannerPosition={this.props.realEstateId}
          locale="en"
          metasiteGuid=""
          translationsUrl={`https://static.parastorage.com/services/dealer-cms-translations/${this.props.translationVersion}/`}
          banner={banner}
          additionalBiParams={{
            _uuid: userGuid || '',
            uuid: userGuid || '',
            client_id: biClientId || '',
          }}
          onEmpty={this.onEmpty}
          onError={this.onEmpty}
        />

        {withCloseButton && (
          <ButtonB5
            className={s['close-button']}
            icon={CloseIconBold}
            iconProps={{ size: IconSize.MEDIUM }}
            onClick={() => this.closeBanner(banner)}
            biData={{
              evid: BiEventType.CLOSE_BANNER_AD,
              realestateid: realEstateId,
              campaignid: banner.bannerId,
            }}
          />
        )}
      </div>
    );
  };

  closeBanner = bannerToClose => {
    const { banners } = this.state;
    this.setState({
      banners: banners.filter(
        banner => banner['bannerId'] !== bannerToClose['bannerId']
      ),
    });
  };

  onEmpty = () => {
    sendCommand('ad-empty', this.props.realEstateId);
    this.setState({ isEmpty: true });
  };
}

export default DealerAd;
